// extracted by mini-css-extract-plugin
module.exports = {"container":"edu-fair_container__3C27n","mainText":"edu-fair_mainText__2lIBW","live":"edu-fair_live__2nr90"};